import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { isNullOrUndefined } from '@sla-ng/core';
import { IReference } from '../../../models/reference.model';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';
import { IReferenceSizeState } from '../../../services/facades/master-data/reference-size-state.model';
import { ReferenceSizeFacade } from '../../../services/facades/master-data/reference-size.facade';
import { ReferenceSizeDialogComponent } from './reference-size-dialog/reference-size-dialog.component';
import { ConfirmDialogComponent } from '@sla-ng/ui-material';
import { MatSort } from '@angular/material/sort';

@Component({
    templateUrl: './reference-size.page.html',
    styleUrls: [ './reference-size.page.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceSizePage implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild(MatPaginator)
    public paginator: MatPaginator;
    @ViewChild(MatSort)
    public sort: MatSort;

    public dataSource: MatTableDataSource<IReference> = new MatTableDataSource<IReference>([]);
    public referenceSizeState$: Observable<IReferenceSizeState>;
    private destroy$: Subject<void> = new Subject();

    constructor(private myReferenceSizeFacade: ReferenceSizeFacade,
                private myMatDialog: MatDialog) {
    }

    public ngOnInit(): void {
        this.referenceSizeState$ = this.myReferenceSizeFacade.subState();
        this.referenceSizeState$
            .pipe(
                takeUntil(this.destroy$),
                map((s: IReferenceSizeState) => s.data),
                distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
            .subscribe((data: IReference[]) => {
                this.dataSource.data = data;
            });
        void this.myReferenceSizeFacade.fetchData();
    }

    public ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.myReferenceSizeFacade.clearState();
    }

    public onOpenDialog(reference?: IReference): void {
        const dialog: MatDialogRef<ReferenceSizeDialogComponent> = this.myMatDialog.open(ReferenceSizeDialogComponent, {
            width: '600px',
            data: isNullOrUndefined(reference) ? {} : reference,
        });
        dialog.afterClosed().subscribe((update: boolean) => {
            if (update) {
                void this.myReferenceSizeFacade.fetchData();
            }
        });
    }

    public onDeleteReference(reference: IReference): void {
        const dialog: MatDialogRef<ConfirmDialogComponent> = this.myMatDialog.open(ConfirmDialogComponent, {
            width: '600px',
            data: {
                message: 'app.page.reference.confirm-delete.label',
                messageParams: { name: reference.name }
            },
        });
        dialog.afterClosed().subscribe(async (isConfirmed: boolean) => {
            if (isConfirmed) {
                await this.myReferenceSizeFacade.deleteReference(reference.id);
            }
        });
    }

    public applyFilter(filterValue: string): void {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

}
